// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38puH","content":"styles_content__3fVeA"};